<template>
  <FlotoFixedView>
    <MTab
      v-model="currentTab"
      position="left"
      default-active="locate_on_map"
      class="px-4 email-server-tabs flex-tab"
    >
      <MTabPane
        key="locate_on_map"
        :tab="$tc('locate_on_map')"
        class="flex flex-col h-100"
      >
        <LocateOnMap
          v-if="currentTab === 'locate_on_map'"
          :resource="resource"
          :disabled="disabled"
        />
      </MTabPane>
      <MTabPane
        key="geolocation_detail"
        :tab="$tc('geolocation_detail')"
        class="flex flex-col h-100"
      >
        <GeolocationDetail
          v-if="currentTab === 'geolocation_detail'"
          :asset-config-info="assetConfigInfo"
          :resource="resource"
          :disabled="disabled"
          @refresh="$emit('refresh', $event)"
        />
      </MTabPane>
      <MTabPane
        key="geolocation_history"
        :tab="$tc('geolocation_history')"
        class="flex flex-col h-100"
      >
        <GeolocationHistory
          v-if="currentTab === 'geolocation_history'"
          :resource-id="resource.id"
          :disabled="disabled"
          :module-name="$constants.ASSET_GEOLOCATION"
        />
      </MTabPane>
    </MTab>
  </FlotoFixedView>
</template>

<script>
import LocateOnMap from './locate-on-map.vue'
import GeolocationDetail from './geolocation-details.vue'
import GeolocationHistory from './geolocation-history.vue'
export default {
  name: 'GeoLocationTab',
  components: { LocateOnMap, GeolocationDetail, GeolocationHistory },
  props: {
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
    assetConfigInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
  },
  data() {
    return {
      currentTab: 'locate_on_map',
    }
  },
}
</script>
